

import { getPageTitle } from '~/assets/js/seo/title.js';
import { mapGetters } from 'vuex';
const environment = process.env.NODE_ENV || 'production';
const envSet = require(`~/api/env.${environment}.js`)
import { nextTick } from 'vue';

export default {

	data() {
		return {
			model: [
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 },
				{ src: '/assets/models/blender/particle/nuts-half.glb', scale: 0.8 }
			],
			page: {
				'ja':`
### **第1条（基本方針）**

Garden Eight（以下「当社」といいます。）は、本サービスにおけるユーザーのプライバシーを保護することを重要な責務と認識しております。本プライバシーポリシー（以下「本ポリシー」といいます。）は、本サービスにおけるユーザーのプライバシーを保護するための当社の方針を定めるものです。

### **第2条（特定の技術の使用目的）**

当社は、本サービスを提供するにあたり、以下の目的で特定の技術を使用する場合があります。

- スパム行為が発生した場合にのみ、スパム行為を防止するためのフラグをユーザーのブラウザのlocalStorageに保存

**localStorageの説明**

localStorageは、ウェブブラウザが提供するストレージ機能の一つであり、ユーザーのデバイス上にデータを保存することができます。このデータは、ブラウザを閉じても保持され、ユーザーが再びウェブサイトを訪れた際に再利用することができます。

### **第3条（情報の利用目的）**

当社は、ユーザーのブラウザのlocalStorageに保存された情報を以下の目的で利用します。

- スパム行為や不正行為を防止するため
- ユーザー体験の向上とサービスの健全な運営のため

### **第4条（個人情報の収集）**

当社は、本サービスを通じて個人情報を収集しませんが、OpenAIのサービスを利用しています。OpenAIのプライバシーポリシーは [https://openai.com/ja-JP/policies/privacy-policy/](https://openai.com/ja-JP/policies/privacy-policy/)でご確認ください。localStorageに保存される情報は、個人を特定できる情報を含みません。

### **第5条（情報の第三者提供）**

当社は、法令に基づく場合を除き、ユーザーの情報を第三者に提供することはありません。なお、localStorageに保存された情報はユーザーのデバイスにのみ保存されます。

### **第6条（情報の管理）**

当社は、ユーザーのブラウザのlocalStorageに保存された情報が適切に管理されるよう努めますが、これらの情報はユーザーのデバイス上にあり、当社が直接管理するものではありません。

### **第7条（ユーザーの権利）**

ユーザーは、自身のブラウザのlocalStorageに保存された情報に関して、設定を変更する権利を有します。これらの権利を行使するためには、ブラウザの設定をご確認ください。

### **第8条（プライバシーポリシーの変更）**

当社は、本ポリシーを随時変更することができるものとします。変更後のポリシーは、本サービスに掲載された時点から効力を生じるものとします。

### **第9条（お問い合わせ）**

本ポリシーに関するお問い合わせは、以下の連絡先までお願いいたします。

- 連絡先：hello@garden-eight.com
`,
				'en':`
### **第1条（基本方針）**

Garden Eight（以下「当社」といいます。）は、本サービスにおけるユーザーのプライバシーを保護することを重要な責務と認識しております。本プライバシーポリシー（以下「本ポリシー」といいます。）は、本サービスにおけるユーザーのプライバシーを保護するための当社の方針を定めるものです。

### **第2条（特定の技術の使用目的）**

当社は、本サービスを提供するにあたり、以下の目的で特定の技術を使用する場合があります。

- スパム行為が発生した場合にのみ、スパム行為を防止するためのフラグをユーザーのブラウザのlocalStorageに保存

**localStorageの説明**

localStorageは、ウェブブラウザが提供するストレージ機能の一つであり、ユーザーのデバイス上にデータを保存することができます。このデータは、ブラウザを閉じても保持され、ユーザーが再びウェブサイトを訪れた際に再利用することができます。

### **第3条（情報の利用目的）**

当社は、ユーザーのブラウザのlocalStorageに保存された情報を以下の目的で利用します。

- スパム行為や不正行為を防止するため
- ユーザー体験の向上とサービスの健全な運営のため

### **第4条（個人情報の収集）**

当社は、本サービスを通じて個人情報を収集しませんが、OpenAIのサービスを利用しています。OpenAIのプライバシーポリシーは [https://openai.com/ja-JP/policies/privacy-policy/](https://openai.com/ja-JP/policies/privacy-policy/)でご確認ください。localStorageに保存される情報は、個人を特定できる情報を含みません。

### **第5条（情報の第三者提供）**

当社は、法令に基づく場合を除き、ユーザーの情報を第三者に提供することはありません。なお、localStorageに保存された情報はユーザーのデバイスにのみ保存されます。

### **第6条（情報の管理）**

当社は、ユーザーのブラウザのlocalStorageに保存された情報が適切に管理されるよう努めますが、これらの情報はユーザーのデバイス上にあり、当社が直接管理するものではありません。

### **第7条（ユーザーの権利）**

ユーザーは、自身のブラウザのlocalStorageに保存された情報に関して、設定を変更する権利を有します。これらの権利を行使するためには、ブラウザの設定をご確認ください。

### **第8条（プライバシーポリシーの変更）**

当社は、本ポリシーを随時変更することができるものとします。変更後のポリシーは、本サービスに掲載された時点から効力を生じるものとします。

### **第9条（お問い合わせ）**

本ポリシーに関するお問い合わせは、以下の連絡先までお願いいたします。

- 連絡先：hello@garden-eight.com
`
			},
			error: null
		};
	},

	computed: {
		...mapGetters([
			'chatAi'
		]),
		pageContent() {
			const lang = this.$i18n.locale;
			const mdContent = this.page[lang];
			return this.$md.render( mdContent );
		}
	},

	head() {
		let _title = getPageTitle(this.$i18n.locale, 'Privacy Policy');
		let _description = 'Privacy Policy';
		return {
			title: _title,
			meta: [
				{
					name: 'description',
					content: _description,
				}
			]
		}
	},

	async fetch ({ store, $http }) {
		if( !store.getters.projects.length ){
			const request = `${envSet.staticUrl}/db/projects.json`;
			const response = await $http.$get( request );
			store.dispatch( 'setProjects', response );
		}
	},

	mounted(){
		ROUTE.onMounted( this.$store.$device, {
			current : { type : 'subpage', slug : 'subpage' },
			prev : null,
			next : null
		});
	},

	transition : {
		mode: 'out-in',
		css: false,
		beforeEnter( el ){
			ROUTE.beforeEnter( el );
		},
		enter( el, done ){
			ROUTE.enter( el, done );
		},
		afterEnter( el ){
			ROUTE.afterEnter( el );
		},
		leave( el, done ){
			ROUTE.leave(el, done);
		},
	}

}
